export default __webpack_public_path__ + "static/media/290-tile.d032c6c8.svg";